import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'light' | 'dark';

export interface SettingsState {
  theme: ThemeMode;
  sidebarCollapsed: boolean;
  notificationsEnabled: boolean;
  workingDate: string;
}

const THEME_KEY = 'hccc.theme';

const initialState: SettingsState = {
  theme: (localStorage.getItem(THEME_KEY) as ThemeMode | null) ?? 'light',
  sidebarCollapsed: false,
  notificationsEnabled: true,
  workingDate: new Date().toISOString(),
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<ThemeMode>) {
      state.theme = action.payload;
      localStorage.setItem(THEME_KEY, action.payload);
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebar(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    setNotificationsEnabled(state, action: PayloadAction<boolean>) {
      state.notificationsEnabled = action.payload;
    },
    setWorkingDate(state, action: PayloadAction<string>) {
      state.workingDate = action.payload;
    },
  },
});

export const { setTheme, toggleSidebar, setSidebar, setNotificationsEnabled, setWorkingDate } =
  settingsSlice.actions;
export default settingsSlice.reducer;
